import { Callout } from '@dev-spendesk/grapes';

import { useCompany } from 'modules/app/hooks/useCompany';
import { QueryError } from 'src/core/common/components/QueryError';
import { QuerySuspense } from 'src/core/common/components/QuerySuspense';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { formatMoney } from 'src/core/utils/money';

import { getCalloutTitleKey } from './calloutTranslationHelpers';
import { useSpendLimitsQuery } from '../../hooks/useSpendLimitsQuery';
import { type SpendLimitPeriod } from '../../models/spendLimit';

export const GeneralLimitCallout = ({
  expenseCategoryId,
  className,
}: {
  expenseCategoryId: string;
  className?: string;
}) => {
  const { t } = useTranslation('global');
  const spendLimitsQueryState = useSpendLimitsQuery();
  const company = useCompany();

  return (
    <QuerySuspense
      loading={null}
      queryState={spendLimitsQueryState}
      fallback={(error) => (
        <QueryError queryError={error} componentType="Callout" />
      )}
    >
      {(spendLimits) => {
        const spendLimit = spendLimits.find(
          (limit) => limit.customFieldValueId === expenseCategoryId,
        );
        if (spendLimit) {
          return (
            <Callout
              className={className}
              variant="info"
              title={t('spendLimits.modal.request.calloutInfo.title')}
            >
              <ul className="list-inside list-disc space-y-2">
                {(
                  Object.entries(spendLimit.limits) as [
                    SpendLimitPeriod,
                    number,
                  ][]
                ).map(([period, amount]) => {
                  const calloutTitleKey = getCalloutTitleKey(period);

                  return (
                    <li key={period}>
                      {t(calloutTitleKey, {
                        amount: formatMoney(amount, company.currency),
                      })}
                    </li>
                  );
                })}
              </ul>
            </Callout>
          );
        }
        return null;
      }}
    </QuerySuspense>
  );
};
